module.exports = __webpack_public_path__ + "img/entenda-o-mercado.svg";